import angular from 'angular';

angular.module('myConsultApp').directive('inputSelectMultipleSync', () => {
  return {
    templateUrl: 'templates/v2/input-select-multiple-sync.html',
    restrict: 'E',
    scope: {
      id: '@',
      options: '=',
      titleField: '@',
      valueField: '@',
      initialValue: '=',
      onSelect: '&',
    },
    link: ($scope) => {
      $scope.selectedOptions = $scope.initialValue || [];

      $scope.selectOption = (option) => {
        const optionValue = option[$scope.valueField];

        if ($scope.selectedOptions.indexOf(optionValue) > -1) {
          $scope.selectedOptions = $scope.selectedOptions.filter((elem) => elem !== optionValue);
        } else {
          $scope.selectedOptions = [...$scope.selectedOptions, optionValue];
        }

        $scope.onSelect({
          options: $scope.options
            .map((elem) => elem[$scope.valueField])
            .filter((elem) => $scope.selectedOptions.includes(elem)),
        });
      };

      $scope.$watch('initialValue', () => {
        $scope.selectedOptions = $scope.initialValue || [];
      });
    },
  };
});
